import AppCore from './core/app-core.js';

/**
 * FileToQR 애플리케이션 진입점
 * DOM이 준비되면 AppCore를 초기화합니다.
 */
document.addEventListener('DOMContentLoaded', () => {
    // AppCore 인스턴스를 생성하고 전역에서 접근 가능하도록 window 객체에 할당합니다.
    const app = new AppCore();
    window.FileToQR = app;

    // 애플리케이션 초기화를 시작합니다.
    app.init().catch(error => {
        console.error('A critical error occurred during application initialization:', error);
        // 사용자에게 오류를 알리는 UI를 표시할 수 있습니다.
        // 예: document.body.innerHTML = 'Error loading application.';
    });
}); 